import { interaction } from "@origin-digital/reporting-client";
import { IPropertySelection } from "@origin-digital/event-dispatcher";

export const handleSelectedPropertyAnalytics = (
  selectedPropertyId: string | undefined,
  activeProperties: (IPropertySelection | undefined)[],
  inactiveProperties: (IPropertySelection | undefined)[]
): void => {
  if (!selectedPropertyId) {
    trackAllActivePropertiesClick();
    return;
  }

  const activeIndex = activeProperties.findIndex(
    (p) => p?.id === selectedPropertyId
  );
  const inactiveIndex = inactiveProperties.findIndex(
    (p) => p?.id === selectedPropertyId
  );

  const isActive = activeIndex !== -1;
  const position = isActive ? activeIndex + 1 : inactiveIndex + 1;

  trackPropertyClick(isActive, position);
};

export const trackPropertySelectorOpen = (propertyAmount: number): void => {
  interaction("click", {
    componentType: "modal",
    id: "propertySelector",
    parentContainer: "",
    label: `${propertyAmount} available`,
    state: "opened",
  });
};

export const trackAllActivePropertiesClick = (): void => {
  interaction("click", {
    componentType: "button",
    id: "allActiveProperties",
    parentContainer: "propertySelector",
    label: "All Active Properties",
  });
};

export const trackPropertyClick = (
  isActive: boolean,
  position: number
): void => {
  const statusLabel = isActive ? "Property" : "Inactive Property";
  interaction("click", {
    componentType: "button",
    id: `property${position}`,
    parentContainer: "propertySelector",
    label: `${statusLabel} Number ${position}`,
  });
};

export const trackPropertySelectorClose = (): void => {
  interaction("click", {
    componentType: "button",
    id: "close",
    parentContainer: "propertySelector",
    label: "Close property selector",
  });
};

export const trackMoveInClick = (): void => {
  interaction("click", {
    componentType: "button",
    id: "move",
    parentContainer: "propertySelector",
    label: "Move in to a new property",
  });
};

export const trackDisconnectClick = (): void => {
  interaction("click", {
    componentType: "button",
    id: "disconnect",
    parentContainer: "propertySelector",
    label: "Disconnect a property",
  });
};
